import { CreateContainer } from "./ContainerCreate";
import LoadMoreContainer from "./LoadMoreContainer";
import { getArtistTracks } from "../api/getArtist";

import { ARTIST_TRACKS_PER_PAGE } from "../totdConfig";

class ArtistTracksContainer extends LoadMoreContainer {
  constructor(props) {
    super(props);
    this.state = { page: 1, hasMore: false, type: "track", filter: this.props.filter, items: [] };
  }
  fetch = () => {
    this.props.request(this.state.filter, this.state.page).then(data => {
      const hasMore = data && data.data.length === ARTIST_TRACKS_PER_PAGE;
      const items = this.state.items.slice(0);
      data.data.map(t => items.push(t));
      this.setState({ items, page: (this.state.page += 1), hasMore });
    });
  };
}

ArtistTracksContainer.defaultProps = {};
export default CreateContainer(getArtistTracks, ArtistTracksContainer);
